<template>
  <div class="view-detail__wrapper">
    <div class="view-detail__header">
      <div
        @click="$emit('hide')"
        class="cursor-pointer"
      >
        <aha-icon name="arrow-left" />
      </div>
      <p class="text-sm text-secondary-100">
        <aha-icon
          name="info-circle"
          class="text-base-70 mt-0.5"
          viewBox="0 0 24 24"
          width="22"
          height="22"
        />
        {{ $i18nPresenter.t("View detail") }}
      </p>
      <div>
      </div>
    </div>
    <div class="view-detail__body">
      <div class="body__table--wrapper">
        <div class="body__table-content">
          <table class="w-full">
            <tbody>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Presentation") }}
                </td>
                <td class="text-right">
                  {{ presentation.name }}
                </td>
              </tr>
              <tr v-if="!hideRowOwner">
                <td class="font-bold">
                  {{ $i18nPresenter.t("Owner") }}
                </td>
                <td class="text-right">
                  <presentation-owner
                    class="justify-end"
                    :data="presentation"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Status") }}
                </td>
                <td class="text-right">
                  <div class="flex items-center justify-end">
                    <private-mode-button class="mr-1" :presentation="presentation" />
                    <p>{{ presentation.privateMode ? 'Private' : 'Public' }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Publish to community") }}
                </td>
                <td class="text-right">
                  <div class="flex items-center justify-end">
                    <p>{{ presentation.isPublicSearch ? 'Yes' : 'No' }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Number of slides") }}
                </td>
                <td class="text-right">
                  <aha-icon-container>
                    <aha-svg
                      class="text-secondary-50"
                      name="slides"
                      view-box="0 0 12 12"
                      size="xs"
                    />
                  </aha-icon-container>
                  {{ presentation.slideCount }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Total participants") }}
                </td>
                <td class="text-right">
                  <aha-icon-container>
                    <aha-svg class="text-secondary-50" name="people" size="sm" />
                  </aha-icon-container>
                  {{ presentation.participantsCount || 0 }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Largest live audience") }}
                </td>
                <td class="text-right">
                  <aha-icon-container>
                    <aha-svg class="text-secondary-50" name="people" size="sm" />
                  </aha-icon-container>
                  {{ presentation.onlineCount }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Access code") }}
                </td>
                <td class="text-right">
                  {{ presentation.accessCode }}
                </td>
              </tr>
              <tr v-if="isReactionsDetailVisible">
                <td class="font-bold">
                  {{ $i18nPresenter.t("Reactions") }}
                </td>
                <td class="text-right">
                  <Reactions :presentation="presentation" />
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Created") }}
                </td>
                <td class="text-right">
                  <aha-formatter
                    :value="presentation.createdAt"
                    type="date"
                    :locale="locale"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  {{ $i18nPresenter.t("Last updated") }}
                </td>
                <td class="text-right">
                  <aha-formatter
                    :value="presentation.updatedAt"
                    type="date"
                    :locale="locale"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// FIXME: convert into a common component
import PrivateModeButton from '@/components-v2/presentation-editor/editor-header/PrivateModeButton.vue'
import PresentationOwner from './PresentationOwner.vue'
import Reactions from './Reactions.vue'
import ahaSystem from '@/constant/ahaSystem'

export default {
  components: {
    PrivateModeButton,
    PresentationOwner,
    Reactions,
  },
  props: {
    presentation: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.presenterLocale,
    }),
    isReactionsDetailVisible() {
      return this.presentation.reactions &&
            Object.values(this.presentation.reactions).some((reaction) => reaction === true)
            && this.numberOfReactions !== 0
    },
    numberOfReactions() {
      const {
        numberOfLikes,
        numberOfHearts,
        numberOfLaughs,
        numberOfWows,
        numberOfSads,
      } = this.presentation

      return numberOfLikes + numberOfHearts + numberOfLaughs + numberOfWows + numberOfSads
    },
    hideRowOwner() {
      if (this.presentation.User && this.presentation.User.email === ahaSystem.email) return true
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.view-detail__wrapper {
  @apply fixed top-16 left-0 z-10 bg-primary-50 h-screen;
  @apply flex flex-col w-full overflow-y-scroll;
}

.view-detail__header {
  @apply p-4 text-base-90;
  @apply w-full flex justify-between shadow-top bg-base-0;
  z-index: 1;
}

.view-detail__body {
 @apply bg-primary-50;
 @apply flex justify-center w-full;
 .body__table--wrapper {
   @apply bg-base-0;
   @apply m-5 w-full border-collapse rounded-lg;
 }
}

.body__table-content {
  @apply py-3 px-4 rounded-lg shadow;
  td {
    @apply py-2;
  }
}
</style>
